import React from 'react';
// import MaterialTable from "material-table";
import {tablePageRowsRate, defaultRowsRate} from '../../constants/ReusableTablePagination';
import {tableIcons} from '../../components/TableIcons';
import GuiTable from '../../components/FormComponents/GuiTable';

function RateTables(props) {
  const columns = [
    {title: 'Sub Service Type', field: 'subServiceType'},
  ];
  const data = [
    {
      subServiceType: 'Medicare Weekly Placements(WMC)',
    },
    {
      subServiceType: 'DSP Accounts',
    },
    {
      subServiceType: 'Community Accounts(COM)',
    },
    {
      subServiceType: 'Flow Forward Accounts',
    },
  ];

  return (
    <div className="custom-table ">
      <GuiTable
        columns={columns}
        data={data}
        title="Medicare Weekly Placements"
        icons={tableIcons}
        options={{
          filtering: false,
          pageSize: defaultRowsRate,
          pageSizeOptions: tablePageRowsRate,
          search: true,
          emptyRowsWhenPaging: false,
        }}
      />
    </div>
  );
}

export default RateTables;
